import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/logo.png';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isLoansDropdownOpen, setIsLoansDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navRef = useRef(null);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  // Handle scroll to show/hide header
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show header at the top of the page
      if (currentScrollY < 10) {
        setIsHeaderVisible(true);
      } 
      // Hide header when scrolling down, show when scrolling up
      else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down
        setIsHeaderVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up
        setIsHeaderVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <header className={`header ${isHeaderVisible ? 'visible' : 'hidden'}`}>
      {/* Top Information Bar */}
      <div className="top-bar">
        <div className="top-bar-scroll">
          <div className="top-bar-content">
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
            <span className="registration-info">
              <span className="checkmark-circle">✓</span> RBI Registered NBFC ND-II COR No. 01.00029
            </span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="main-nav" ref={navRef}>
        <div className="container">
          <div className="nav-content">
            {/* Logo */}
            <div className="logo">
              <Link to="/" className="logo-link" onClick={() => setIsMobileMenuOpen(false)}>
                <img src={logo} alt="Ampire Finance" className="logo-image" />
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button 
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
              <div 
                className="mobile-menu-overlay" 
                onClick={() => setIsMobileMenuOpen(false)}
              ></div>
            )}

            {/* Navigation Links */}
            <ul className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
              <li>
                <Link 
                  to="/" 
                  className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/dlas" 
                  className={`nav-link ${/^\/dlas?\/?$/.test(location.pathname) ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Digital Lending Partners
                </Link>
              </li>
              <li 
                className="dropdown-container"
                onMouseEnter={() => setIsLoansDropdownOpen(true)}
                onMouseLeave={() => setIsLoansDropdownOpen(false)}
              >
                <button 
                  className={`nav-link dropdown ${location.pathname === '/loans' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsLoansDropdownOpen(!isLoansDropdownOpen);
                  }}
                >
                  Loans
                  <span className={`dropdown-arrow ${isLoansDropdownOpen ? 'open' : ''}`}>▼</span>
                </button>
                {isLoansDropdownOpen && (
                  <ul className="dropdown-menu">
                    <li>
                      <Link to="/loans/property" onClick={() => setIsMobileMenuOpen(false)}>Loan against Property</Link>
                    </li>
                    <li>
                      <Link to="/loans/shares" onClick={() => setIsMobileMenuOpen(false)}>Loan against Shares</Link>
                    </li>
                    <li>
                      <Link to="/loans/personal" onClick={() => setIsMobileMenuOpen(false)}>Personal Loan</Link>
                    </li>
                    <li>
                      <Link to="/loans/used-vehicle" onClick={() => setIsMobileMenuOpen(false)}>Used Vehicle Loan</Link>
                    </li>
                    <li>
                      <Link to="/loans/invoice-discounting" onClick={() => setIsMobileMenuOpen(false)}>Invoice Discounting</Link>
                    </li>
                    <li>
                      <Link to="/loans/msme" onClick={() => setIsMobileMenuOpen(false)}>MSME Loan</Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link 
                  to="/partner" 
                  className={`nav-link ${location.pathname === '/partner' ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Become A Partner
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className={`nav-link ${location.pathname === '/privacy' ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Privacy Policy
                </Link>
              </li>
              {/* Contact Button in Mobile Menu */}
              <li className="contact-button-mobile">
                <Link 
                  to="/contact" 
                  className="btn btn-primary"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  CONTACT US
                  <span className="envelope-icon">✉</span>
                </Link>
              </li>
            </ul>

            {/* Contact Button - Desktop Only */}
            <div className="contact-button">
              <Link 
                to="/contact" 
                className="btn btn-primary"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                CONTACT US
                <span className="envelope-icon">✉</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
